export default __webpack_public_path__ + "static/media/fileuploadpopup.1f047a9d.svg";